import React from 'react';

import { ListingCard } from '../../../components';

const SearchListingCard = props => {
  return <ListingCard {...props} isSearchResultCard />;
};

export default SearchListingCard;
